var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchNotFound = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 190,
  height: 190,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#searchNotFound_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F7",
  d: "M95 165c38.66 0 70-31.34 70-70s-31.34-70-70-70-70 31.34-70 70 31.34 70 70 70"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#searchNotFound_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M41 54h135a5 5 0 0 1 5 5v25a5 5 0 0 1-5 5H41a5 5 0 0 1-5-5V59a5 5 0 0 1 5-5"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#DADAE6",
  d: "M112 62H86a3 3 0 1 0 0 6h26a3 3 0 1 0 0-6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E9E9F6",
  d: "M130 75H86a3 3 0 1 0 0 6h44a3 3 0 1 0 0-6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M73 72c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M62.424 74.848a3.4 3.4 0 0 0 2.093-.721l1.88 1.88.604-.605-1.88-1.88a3.417 3.417 0 1 0-2.697 1.326m0-5.987a2.567 2.567 0 1 1 0 5.135 2.567 2.567 0 0 1 0-5.135"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#searchNotFound_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M148 99H13a5 5 0 0 0-5 5v25a5 5 0 0 0 5 5h135a5 5 0 0 0 5-5v-25a5 5 0 0 0-5-5"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#DADAE6",
  d: "M84 107H58a3 3 0 1 0 0 6h26a3 3 0 1 0 0-6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E9E9F6",
  d: "M102 120H58a3 3 0 1 0 0 6h44a3 3 0 1 0 0-6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M44 116c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M33.424 118.848c.758 0 1.495-.254 2.093-.721l1.88 1.879.604-.604-1.88-1.88a3.42 3.42 0 0 0-1.975-5.43 3.418 3.418 0 1 0-.723 6.756m0-5.987a2.568 2.568 0 1 1-.002 5.137 2.568 2.568 0 0 1 .002-5.137"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "searchNotFound_svg__b",
  width: 173,
  height: 63,
  x: 22,
  y: 46,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.220263 0 0 0 0 0.247383 0 0 0 0 0.320284 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7257_870"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7257_870",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "searchNotFound_svg__c",
  width: 173,
  height: 63,
  x: -6,
  y: 91,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.220263 0 0 0 0 0.247383 0 0 0 0 0.320284 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7257_870"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7257_870",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "searchNotFound_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h190v190H0z"
})))));
export { SvgSearchNotFound as ReactComponent };
export default "data:image/svg+xml;base64,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";